<template>
  <div :class="['item', itemWidth(item), itemHeight(item), isItemDisabled() ? 'is-disabled' : '']">
    <div :class="['item__note', 'item__note--' + item.position]" v-if="item.type === 'collection'">
      <span>{{ item.story }}</span>
    </div>
    <figure @click="showModal(index)" v-if="item.image">
      <img :src="imagePath">
    </figure>
    <modal :item="item" v-show="show" v-on:hide="hideModal()"></modal>
  </div>
</template>

<script>
import EventBus from '@/event-bus.js'
import Modal from '@/components/Modal'
export default {
  name: 'item',
  props: ['item', 'index', 'previousItem', 'nextItem'],
  components: {
    'modal': Modal
  },
  data () {
    return {
      show: false
    }
  },
  computed: {
    imagePath () {
      let image = this.item.image
      let path = image.indexOf('http') === 0 ? image : require('@/assets/' + image)
      return path
    }
  },
  methods: {
    itemWidth (item) {
      return item.width ? 'item--width' + item.width : ''
    },
    itemHeight (item) {
      return item.height ? 'item--height' + item.height : ''
    },
    isItemDisabled () {
      return !this.item.name || (this.item.width !== this.item.height) || this.item.type === 'collection'
    },
    hideModal () {
      this.show = false
    },
    showModal () {
      if (this.isItemDisabled()) {
        return
      }
      this.show = true
      this.$emit('active', this.index)
      EventBus.$emit('showModal', true)
      document.querySelector('body').style.overflow = 'hidden'
    }
  },
  created () {
    EventBus.$on('showModal', (show) => {
      if (!show) {
        this.hideModal()
        this.$emit('active', null)
      }
    })
    EventBus.$on('showPrevious', (isInstafeed) => {
      this.hideModal()
      if (this.index === this.previousItem && this.$el.closest('.instafeed') === isInstafeed) {
        this.showModal()
      }
    })
    EventBus.$on('showNext', (isInstafeed) => {
      this.hideModal()
      if (this.index === this.nextItem && this.$el.closest('.instafeed') === isInstafeed) {
        this.showModal()
      }
    })
  }
}
</script>

<style lang="scss">
$width: 28px;
$gutter: 40px;

.item {
  display: inline-block;
  width: $width;
  height: $width;
  margin-bottom: 40px;

  &__note {
    background: white;
    box-shadow: 17px 22px 0px 0px rgba(0, 0, 0, 0.2);
    font-family: 'CorporateS', sans-serif;
    font-size: 28px;
    font-weight: 400;
    padding: 50px;
    display: inline-block;
    width: 500px;
    position: absolute;
    transform: skewY(-15deg) translateY(-100%);

    &--right {
      right: calc(#{$width} + #{$gutter});
    }

    &--left {
      left: calc(#{$width} + #{$gutter});
    }

    span {
      display: inline-block;
      transform: skew(15deg)
    }
  }

  &:not(.is-disabled) {
    > figure {
      cursor: pointer;
      transition: all .2s ease-in-out;

      &:hover {
        transform: scale(1.02)
      }
    }
  }

  @for $i from 2 through 24 {
    &--width#{$i} {
      width: calc((#{$width} * #{$i}) + (#{$gutter} * (#{$i} - 1)));
    }
  }

  @for $i from 2 through 24 {
    &--height#{$i} {
      height: calc((#{$width} * #{$i}) + (#{$gutter} * (#{$i} - 1)));
    }
  }

  figure {
    margin: 0;
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Item.vue?42e8c032